// src/components/NormalizeUrl.jsx
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NormalizeUrl = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // useLocation().pathname only contains the path (e.g. "//surveys/adhd"),
        // it never includes "http://", so it's completely safe from breaking protocols!
        if (/\/{2,}/.test(location.pathname)) {
            const cleanPathname = location.pathname.replace(/\/{2,}/g, '/');
            navigate(`${cleanPathname}${location.search}${location.hash}`, { replace: true });
        }
    }, [location, navigate]);

    return null;
};

export default NormalizeUrl;